import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getAllEvents } from './api';
import type { RecordingEvent } from './model/RecordingEvent';

const EVENTS_QUERY_KEY = 'events';

interface ListOption<T> {
  value: T;
  label: string;
}

export const useAllEvents = (siteId?: number): UseQueryResult<ListOption<string>[], Error> => {
  return useQuery<RecordingEvent[], Error, ListOption<string>[]>(
    `${EVENTS_QUERY_KEY}-${siteId}`,
    () => getAllEvents(siteId as number),
    {
      placeholderData: [],
      select: (list) => {
        return list.map((item) => {
          return {
            value: item.value,
            label: item.value,
          };
        });
      },
      refetchOnWindowFocus: false,
    },
  );
};
